import Vue from 'vue'
import VueRouter from 'vue-router'

const Index = ()=>import('@/views/index');
const Home = ()=>import('@/views/home')
const Consult = ()=>import('@/views/consult')
const Popular = ()=>import('@/views/popular')
const Pathogen = ()=>import ('@/views/pathogen')
const Detail = ()=>import ('@/views/detail')
const LoginIndex = ()=>import ('@/views/login/index')
const Login = ()=>import ('@/views/login/login')
const Sigin = ()=>import ('@/views/login/sigin')
const SendCode = ()=>import ('@/views/login/send_code')
const ResetPwd = ()=>import ('@/views/login/reset_pwd')
const Policy = ()=>import ('@/views/login/policy')
const Disclaimer = ()=>import ('@/views/login/disclaimer')

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'index',
    component: Index,
    children: [
      {
        path: '/',
        name: 'home',
        component: Home
      },
      {
        path: '/consult',
        name: 'consult',
        component:Consult
      },
      {
        path: '/popular',
        name: 'popular',
        component:Popular
      },
      {
        path: '/pathogen',
        name: 'pathogen',
        component: Pathogen
      },
      {
        path: '/detail',
        name: 'detail',
        component: Detail
      }
    ]
  },
  {
    path: '/login',
    name: 'loginIndex',
    component: LoginIndex,
    children: [
      {
        path: '/',
        name: 'login',
        component: Login,
        meta: {
          title: '登录',
          keepAlive: true
        }
      },
      {
        path: '/sigin',
        name: 'sigin',
        component: Sigin,
        meta: {
          title: '注册',
          keepAlive: true
        }
      },
      {
        path: '/send_code',
        name: 'SendCode',
        component: SendCode
      },
      {
        path: '/reset_pwd',
        name: 'ResetPwd',
        component: ResetPwd
      },
      {
        path: '/policy',
        name: 'Policy',
        component: Policy
      },
      {
        path: '/disclaimer',
        name: 'Disclaimer',
        component: Disclaimer
      }
    ]
  }
]

const router = new VueRouter({
  routes
})

export default router
